import { render, staticRenderFns } from "./RequestToPaySettings.vue?vue&type=template&id=ea8e5fb2&"
import script from "./RequestToPaySettings.vue?vue&type=script&lang=js&"
export * from "./RequestToPaySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea8e5fb2')) {
      api.createRecord('ea8e5fb2', component.options)
    } else {
      api.reload('ea8e5fb2', component.options)
    }
    module.hot.accept("./RequestToPaySettings.vue?vue&type=template&id=ea8e5fb2&", function () {
      api.rerender('ea8e5fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/SettingsList/RequestToPaySettings.vue"
export default component.exports